import { get, post } from '@/services/Axios';
import qs from 'qs';
import debounce from 'lodash.debounce';
import errorHandler from '@/mixins/errorHandler';

export default {
  mixins: [errorHandler],
  data() {
    return {
      unitOptions: [],
      units: [],
      unit: {},
      paginationUnits: {},
      loadUnitOptions: false,
      loadUnits: true,
      loadFormUnit: false,
      loadUnit: false,
      loadExportUnit: false,
      formUnitOptionsName: '',
      searchUnitsOptions: ''
    };
  },
  watch: {
    searchUnitsOptions(val) {
      if (
        this[this.formUnitOptionsName] &&
        (!this[this.formUnitOptionsName].unit ||
          val !== this[this.formUnitOptionsName].unit.unitName)
      ) {
        this.getUnitOptions({ keyword: val });
      }
    }
  },
  methods: {
    getUnitOptions: debounce(async function(...param) {
      this.loadUnitOptions = true;
      const parameter = param[0] || {};
      const params = {
        sort: parameter.sorts || 'account_name',
        dir: parameter.dir || 'ASC',
        filter: [
          {
            type: 'string',
            field: 'unit_name',
            value: param.keyword || '',
            comparison: '<>'
          }
        ]
      };
      if (param.filters) {
        this.params.filter.push(...param.filters);
      }
      try {
        const {
          data: { results }
        } = await get('/unit/list-option', { params });
        this.unitOptions = results;
        return results;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadUnitOptions = false;
      }
    }, 500),
    async getUnits(...param) {
      const parameter = param[0] || {};
      this.loadUnits = true;
      const params = {
        limit: parameter.limit || 10,
        page: parameter.page || 1,
        sort: parameter.sorts || 'account_name',
        dir: parameter.dir || 'ASC',
        filter: []
      };
      if (parameter.filters) {
        params.filter.push(...parameter.filters);
      }
      try {
        const {
          data: { results, pagination }
        } = await get('/master/unit/list', { params });
        this.units = results;
        this.paginationUnits = pagination;
        return results;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadUnits = false;
      }
    },
    async getUnit(id) {
      this.loadUnit = true;
      const params = {
        unit_id: id
      };
      try {
        const { data } = await get('/master/unit/detail', { params });
        this.unit = data;
        return data;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadUnit = false;
      }
    },
    valueTokoh(value) {
      if (value[0] && !value[0].nama && !value[0].jabatan) {
        return [];
      } else {
        return JSON.stringify(value);
      }
    },

    async createUnit(request) {
      this.loadFormUnit = true;
      const requestBody = {
        name: request.name,
        address: request.address,
        subdistrict_id: request.subdistrict.subdistrictId,
        district_id: request.district.districtId,
        latitude: request.latitude,
        longitude: request.longitude,
        is_active: request.is_active ? 1 : 0,
        type: request.type,
        image: request.image, //optional
        // Type Balai Desa
        jumlah_penduduk: request.jumlah_penduduk,
        kondisi_geografis: request.kondisi_geografis,
        tokoh_daerah: this.valueTokoh(request.tokoh_daerah),
        tokoh_masyarakat: this.valueTokoh(request.tokoh_masyarakat),
        tokoh_agama: this.valueTokoh(request.tokoh_agama),
        kerawanan: request.kerawanan,
        bencana_alam: request.bencana_alam,
        konstelasi_politik: request.konstelasi_politik
      };
      const payload = qs.stringify(requestBody);
      try {
        const { data } = await post('/master/unit/create', { data: payload });
        return data;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadFormUnit = false;
      }
    },
    async updateUnit(request, id) {
      this.loadFormUnit = true;
      const requestBody = {
        id,
        name: request.name,
        address: request.address,
        subdistrict_id: request.subdistrict.subdistrictId,
        district_id: request.district.districtId,
        latitude: request.latitude,
        longitude: request.longitude,
        is_active: request.is_active ? 1 : 0,
        type: request.type,
        image: request.image, //optional
        // Type Balai Desa
        jumlah_penduduk: request.jumlah_penduduk,
        kondisi_geografis: request.kondisi_geografis,
        tokoh_daerah: this.valueTokoh(request.tokoh_daerah),
        tokoh_masyarakat: this.valueTokoh(request.tokoh_masyarakat),
        tokoh_agama: this.valueTokoh(request.tokoh_agama),
        kerawanan: request.kerawanan,
        bencana_alam: request.bencana_alam,
        konstelasi_politik: request.konstelasi_politik
      };
      const payload = qs.stringify(requestBody);
      try {
        const { data } = await post('/master/unit/update', { data: payload });
        return data;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadFormUnit = false;
      }
    },
    async deleteUnit(id) {
      this.loadFormUnit = true;
      const requestBody = { unit_id: id };
      const payload = qs.stringify(requestBody);
      try {
        await post('/master/unit/delete', {
          data: payload
        });
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadFormUnit = false;
      }
    },
    async exportUnit() {
      this.loadExportUnit = true;
      try {
        const {
          data: { url }
        } = await get('/master/unit/export');
        window.open(`${url}?download=1`);
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadExportUnit = false;
      }
    }
  }
};
